// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   ChevronLeft, Save, X, Plus, Building2, Globe, Tag, Users,
//   DollarSign, Mail, Phone, Link2, Clock, UserCheck, Briefcase,
//   BarChart2, CheckCircle2, Circle, AlertCircle, Calendar,
//   Edit2, ListChecks, Activity, FileText, RotateCcw, User,
//   ExternalLink, RefreshCw
// } from 'lucide-react';
// import { companiesAPI, employeesAPI, tasksAPI, contactsAPI } from '../../../services/api';
// import { toast } from 'react-toastify';
// import CreateTaskModal from '../task/CreateTaskModal';
// import TaskEditDrawer from '../task/TaskEditDrawer';

// /* ─── helpers ─── */
// const fmt = (val) =>
//   val ? new Date(val).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';

// const fmtTime = (val) => {
//   if (!val) return '';
//   const d = new Date(val);
//   const now = new Date();
//   const diff = now - d;
//   const mins = Math.floor(diff / 60000);
//   const hrs  = Math.floor(diff / 3600000);
//   const days = Math.floor(diff / 86400000);
//   if (mins < 1)  return 'Just now';
//   if (mins < 60) return `${mins}m ago`;
//   if (hrs < 24)  return `Today, ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
//   if (days === 1) return `Yesterday, ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
//   return fmt(val);
// };

// const LEAD_STATUS_CONFIG = {
//   NEW:              { color: 'text-blue-600',   bg: 'bg-blue-50 border-blue-200',     dot: 'bg-blue-500' },
//   CONTACTED:        { color: 'text-purple-600', bg: 'bg-purple-50 border-purple-200', dot: 'bg-purple-500' },
//   QUALIFIED:        { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',   dot: 'bg-green-500' },
//   QUALIFIED_LEAD:   { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',   dot: 'bg-green-500' },
//   UNQUALIFIED:      { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',       dot: 'bg-red-500' },
//   UNQUALIFIED_LEAD: { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',       dot: 'bg-red-500' },
//   NURTURING:        { color: 'text-amber-600',  bg: 'bg-amber-50 border-amber-200',   dot: 'bg-amber-500' },
// };

// const STAGE_CONFIG = {
//   PROSPECT: { color: 'text-blue-600',   bg: 'bg-blue-50 border-blue-200',    dot: 'bg-blue-500' },
//   LEAD:     { color: 'text-purple-600', bg: 'bg-purple-50 border-purple-200', dot: 'bg-purple-500' },
//   CUSTOMER: { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',  dot: 'bg-green-500' },
//   CHURNED:  { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',      dot: 'bg-red-500' },
// };

// const TASK_STATUS_CONFIG = {
//   PENDING:     { color: 'text-gray-600',  bg: 'bg-gray-100 border-gray-200',  icon: Circle },
//   IN_PROGRESS: { color: 'text-blue-600',  bg: 'bg-blue-50 border-blue-200',   icon: AlertCircle },
//   COMPLETED:   { color: 'text-green-600', bg: 'bg-green-50 border-green-200', icon: CheckCircle2 },
//   CANCELLED:   { color: 'text-red-600',   bg: 'bg-red-50 border-red-200',     icon: X },
// };

// const PRIORITY_CONFIG = {
//   HIGH:   { color: 'text-red-600',   bg: 'bg-red-50 border-red-200',     label: 'High' },
//   MEDIUM: { color: 'text-amber-600', bg: 'bg-amber-50 border-amber-200', label: 'Medium' },
//   LOW:    { color: 'text-green-600', bg: 'bg-green-50 border-green-200', label: 'Low' },
// };

// const Badge = ({ value, config, className = '' }) => {
//   const cfg = config?.[value?.toUpperCase()] || {};
//   const Icon = cfg.icon;
//   return (
//     <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border
//       ${cfg.bg || 'bg-gray-100 border-gray-200'} ${cfg.color || 'text-gray-600'} ${className}`}>
//       {cfg.dot && <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />}
//       {Icon && <Icon size={11} />}
//       <span>{value?.replace(/_/g, ' ') || '—'}</span>
//     </span>
//   );
// };

// /* ─── Sidebar editable row ─── */
// const SidebarField = ({ field, editingField, editValues, display, onEdit, onSave, onCancel, onChange }) => {
//   const isEditing  = editingField === field.key;
//   const isReadonly = field.type === 'readonly';
//   const Icon = field.icon;
//   return (
//     <div className="py-2.5 border-b border-gray-50 last:border-0">
//       <div className="flex items-center gap-1.5 mb-0.5">
//         {Icon && <Icon size={11} className="text-gray-400 flex-shrink-0" />}
//         <span className="text-[11px] text-gray-400 font-medium uppercase tracking-wide">{field.label}</span>
//       </div>
//       {isEditing ? (
//         <div className="space-y-1.5 mt-1.5">
//           {field.type === 'select' ? (
//             <select value={editValues[field.key] || ''} onChange={onChange}
//               className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500">
//               <option value="">Select…</option>
//               {field.options?.map(o => (
//                 <option key={o.id} value={o.id}>
//                   {o.name || `${o.firstName || ''} ${o.lastName || ''}`.trim() || o.email}
//                 </option>
//               ))}
//             </select>
//           ) : (
//             <input type={field.type || 'text'} value={editValues[field.key] || ''} onChange={onChange}
//               className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500" />
//           )}
//           <div className="flex gap-1.5 justify-end">
//             <button onClick={onCancel} className="flex items-center gap-1 px-2 py-1 text-[11px] text-gray-600 bg-gray-100 hover:bg-gray-200 rounded transition-colors">
//               <X size={10} /> Cancel
//             </button>
//             <button onClick={onSave} className="flex items-center gap-1 px-2 py-1 text-[11px] text-white bg-blue-600 hover:bg-blue-700 rounded transition-colors">
//               <Save size={10} /> Save
//             </button>
//           </div>
//         </div>
//       ) : (
//         <div onClick={!isReadonly ? onEdit : undefined}
//           className={`text-xs text-gray-800 font-medium mt-0.5 rounded px-1 py-0.5 -mx-1
//             ${!isReadonly ? 'cursor-pointer hover:bg-blue-50 hover:text-blue-700 transition-colors' : ''}`}
//           title={!isReadonly ? 'Click to edit' : undefined}>
//           {!display || display === '—'
//             ? <span className="text-gray-400 italic font-normal">{isReadonly ? '—' : 'Not set'}</span>
//             : display}
//         </div>
//       )}
//     </div>
//   );
// };

// /* ─── Task Card ─── */
// const TaskCard = ({ task, onEdit }) => {
//   const statusCfg   = TASK_STATUS_CONFIG[task.status] || TASK_STATUS_CONFIG.PENDING;
//   const priorityCfg = PRIORITY_CONFIG[task.priority];
//   const StatusIcon  = statusCfg.icon;
//   return (
//     <div className="bg-white rounded-lg border border-gray-200 p-4 hover:border-blue-300 hover:shadow-sm transition-all">
//       <div className="flex items-start justify-between gap-2 mb-2">
//         <div className="flex items-start gap-2 min-w-0">
//           <StatusIcon size={15} className={`mt-0.5 flex-shrink-0 ${statusCfg.color}`} />
//           <div className="min-w-0">
//             <p className="text-sm font-semibold text-gray-800">{task.subject || '(No Subject)'}</p>
//             {task.description && (
//               <p className="text-xs text-gray-500 mt-1 line-clamp-2 leading-relaxed">{task.description}</p>
//             )}
//           </div>
//         </div>
//         <span className="text-xs text-gray-400 whitespace-nowrap flex-shrink-0">{fmtTime(task.createdAt)}</span>
//       </div>
//       <div className="flex items-center gap-2 flex-wrap">
//         {task.priority && priorityCfg && (
//           <span className={`text-xs font-medium px-2 py-0.5 rounded border ${priorityCfg.bg} ${priorityCfg.color}`}>
//             {priorityCfg.label}
//           </span>
//         )}
//         {task.type && (
//           <span className="text-xs text-teal-600 bg-teal-50 border border-teal-200 px-2 py-0.5 rounded font-medium">
//             {task.type.replace(/_/g, ' ')}
//           </span>
//         )}
//         {task.status && task.status !== 'PENDING' && <Badge value={task.status} config={TASK_STATUS_CONFIG} />}
//         {task.dueDate && (
//           <div className="flex items-center gap-1 text-xs text-gray-400">
//             <Calendar size={11} /> Due: {fmt(task.dueDate)}
//           </div>
//         )}
//       </div>
//       <div className="mt-2 pt-2 border-t border-gray-50">
//         <button onClick={() => onEdit(task)}
//           className="flex items-center gap-1 text-xs text-gray-500 hover:text-blue-600 transition-colors font-medium">
//           <Edit2 size={12} /> Edit
//         </button>
//       </div>
//     </div>
//   );
// };

// /* ─── Contact Card (right panel) ─── */
// const ContactCard = ({ contact, onNavigate }) => {
//   const fullName = `${contact.firstName || ''} ${contact.lastName || ''}`.trim() || '(No Name)';
//   const initials = `${contact.firstName?.[0] || ''}${contact.lastName?.[0] || ''}`.toUpperCase() || '?';
//   return (
//     <div className="flex items-start gap-3 p-3 rounded-lg border border-gray-100 hover:border-blue-200 hover:bg-blue-50/40 transition-all group">
//       <div className="w-9 h-9 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0 text-orange-700 font-bold text-xs">
//         {initials}
//       </div>
//       <div className="flex-1 min-w-0">
//         <p className="text-sm font-semibold text-gray-800 truncate">{fullName}</p>
//         {contact.jobTitle && (
//           <p className="text-xs text-gray-400 truncate mt-0.5">{contact.jobTitle}</p>
//         )}
//         {contact.email && (
//           <p className="text-xs text-gray-400 truncate mt-0.5">{contact.email}</p>
//         )}
//         {contact.leadStatus && (
//           <Badge value={contact.leadStatus} config={LEAD_STATUS_CONFIG} className="mt-1.5" />
//         )}
//       </div>
//       <button
//         onClick={() => onNavigate(contact.id)}
//         className="opacity-0 group-hover:opacity-100 p-1 rounded hover:bg-blue-100 transition-all"
//         title="View contact"
//       >
//         <ExternalLink size={13} className="text-blue-500" />
//       </button>
//     </div>
//   );
// };

// /* ─── Create & Assign Contact Modal ─── */
// const CreateAssignContactModal = ({ companyId, onClose, onAssigned }) => {
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [email, setEmail] = useState('');
//   const [phone, setPhone] = useState('');
//   const [jobTitle, setJobTitle] = useState('');
//   const [loading, setLoading] = useState(false);

//   const handleCreate = async () => {
//     if (!firstName.trim()) { toast.error('First name is required'); return; }
//     if (!email.trim()) { toast.error('Email is required'); return; }
//     setLoading(true);
//     try {
//       const newContactData = {
//         firstName: firstName.trim(),
//         lastName: lastName.trim(),
//         email: email.trim(),
//         phone: phone.trim(),
//         jobTitle: jobTitle.trim(),
//         companyId: companyId
//       };
//       const response = await contactsAPI.addContact(newContactData);
//       const newContact = response.data;
//       toast.success(`Contact "${newContact.firstName} ${newContact.lastName}" created & assigned!`);
//       onAssigned({ id: newContact.id, firstName: newContact.firstName, lastName: newContact.lastName, email: newContact.email });
//       onClose();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to create contact');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
//       <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
//         <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden">
//           <div className="flex items-center justify-between px-5 py-4 border-b bg-gray-50">
//             <div className="flex items-center gap-2">
//               <Users size={16} className="text-orange-600" />
//               <h3 className="text-sm font-semibold text-gray-900">Create &amp; Assign Contact</h3>
//             </div>
//             <button onClick={onClose} className="p-1 rounded hover:bg-gray-200 text-gray-500 transition-colors">
//               <X size={16} />
//             </button>
//           </div>
//           <div className="px-5 py-4 space-y-4">
//             <div className="grid grid-cols-2 gap-3">
//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-1">
//                   First Name <span className="text-red-500">*</span>
//                 </label>
//                 <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)}
//                   placeholder="First name"
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
//                   onKeyDown={e => e.key === 'Enter' && handleCreate()} />
//               </div>
//               <div>
//                 <label className="block text-xs font-medium text-gray-700 mb-1">Last Name</label>
//                 <input type="text" value={lastName} onChange={e => setLastName(e.target.value)}
//                   placeholder="Last name"
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
//                   onKeyDown={e => e.key === 'Enter' && handleCreate()} />
//               </div>
//             </div>
//             <div>
//               <label className="block text-xs font-medium text-gray-700 mb-1">
//                 Email <span className="text-red-500">*</span>
//               </label>
//               <input type="email" value={email} onChange={e => setEmail(e.target.value)}
//                 placeholder="Contact email"
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
//                 onKeyDown={e => e.key === 'Enter' && handleCreate()} />
//             </div>
//             <div>
//               <label className="block text-xs font-medium text-gray-700 mb-1">Phone</label>
//               <input type="tel" value={phone} onChange={e => setPhone(e.target.value)}
//                 placeholder="Contact phone"
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
//                 onKeyDown={e => e.key === 'Enter' && handleCreate()} />
//             </div>
//             <div>
//               <label className="block text-xs font-medium text-gray-700 mb-1">Job Title</label>
//               <input type="text" value={jobTitle} onChange={e => setJobTitle(e.target.value)}
//                 placeholder="Job title"
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
//                 onKeyDown={e => e.key === 'Enter' && handleCreate()} />
//             </div>
//           </div>
//           <div className="flex gap-2 justify-end px-5 py-4 border-t bg-gray-50">
//             <button onClick={onClose} disabled={loading}
//               className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-100 transition-colors disabled:opacity-60">
//               Cancel
//             </button>
//             <button onClick={handleCreate} disabled={loading}
//               className="flex items-center gap-2 px-4 py-2 text-sm bg-orange-600 text-white rounded-md hover:bg-orange-700 transition-colors disabled:opacity-60 font-medium">
//               {loading
//                 ? <><div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" /> Creating…</>
//                 : <><Plus size={14} /> Create &amp; Assign</>
//               }
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// /* ═══════════════════════════════════════
//    MAIN COMPONENT
// ═══════════════════════════════════════ */
// const CompanyPreviewPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [company, setCompany]                     = useState(null);
//   const [loading, setLoading]                     = useState(true);
//   const [editingField, setEditingField]           = useState(null);
//   const [editValues, setEditValues]               = useState({});
//   const [employeeOptions, setEmployeeOptions]     = useState([]);
//   const [employeeNameCache, setEmployeeNameCache] = useState({});
//   const [tasks, setTasks]                         = useState([]);
//   const [tasksLoading, setTasksLoading]           = useState(false);

//   // Linked contacts (right panel)
//   const [linkedContacts, setLinkedContacts]         = useState([]);
//   const [linkedContactsLoading, setLinkedContactsLoading] = useState(false);

//   // Notes
//   const [notes, setNotes]               = useState('');
//   const [notesLoading, setNotesLoading] = useState(false);
//   const [editingNotes, setEditingNotes] = useState(false);
//   const [notesDraft, setNotesDraft]     = useState('');
//   const [notesSaving, setNotesSaving]   = useState(false);
//   const textareaRef = useRef(null);

//   const [showCreateTaskModal, setShowCreateTaskModal] = useState(false);
//   const [editingTask, setEditingTask]                 = useState(null);
//   const [showCreateAssignContactModal, setShowCreateAssignContactModal] = useState(false);

//   useEffect(() => {
//     fetchCompany();
//     fetchEmployeeOptions();
//     fetchNotes();
//     fetchTasks();
//     fetchLinkedContacts();
//   }, [id]);

//   useEffect(() => {
//     if (!company?.contactOwner) return;
//     const ownerId = company.contactOwner;
//     if (ownerId in employeeNameCache) return;
//     employeesAPI.getEmployeeById(ownerId)
//       .then(res => {
//         const e = res.data;
//         setEmployeeNameCache(p => ({ ...p, [ownerId]: e.name || `${e.firstName || ''} ${e.lastName || ''}`.trim() || e.email || ownerId }));
//       })
//       .catch(() => setEmployeeNameCache(p => ({ ...p, [ownerId]: ownerId })));
//   }, [company?.contactOwner]);

//   useEffect(() => {
//     if (editingNotes && textareaRef.current) {
//       textareaRef.current.focus();
//       const len = textareaRef.current.value.length;
//       textareaRef.current.setSelectionRange(len, len);
//     }
//   }, [editingNotes]);

//   const fetchCompany = async () => {
//     setLoading(true);
//     try {
//       const r = await companiesAPI.getCompanyById(id);
//       setCompany(r.data); setEditValues(r.data);
//     } catch { toast.error('Failed to fetch company details'); navigate('/company'); }
//     finally { setLoading(false); }
//   };

//   const fetchEmployeeOptions = async () => {
//     try {
//       const r = await employeesAPI.getAllEmployees();
//       setEmployeeOptions(r.data.filter(e => e.role?.includes('ATS')));
//     } catch (e) { console.error(e); }
//   };

//   const fetchTasks = async () => {
//     setTasksLoading(true);
//     try {
//       const r = await tasksAPI.gettasksbycompany(id);
//       setTasks(r.data || []);
//     } catch { toast.error('Failed to fetch tasks'); }
//     finally { setTasksLoading(false); }
//   };

//   const fetchNotes = async () => {
//     setNotesLoading(true);
//     try {
//       const r = await companiesAPI.getNotes(id);
//       const n = r.data?.notes || r.data || '';
//       setNotes(n); setNotesDraft(n);
//     } catch { console.error('Failed to fetch notes'); }
//     finally { setNotesLoading(false); }
//   };

//   const fetchLinkedContacts = async () => {
//     setLinkedContactsLoading(true);
//     try {
//       const r = await companiesAPI.getLinkedContacts(id);
//       setLinkedContacts(r.data || []);
//     } catch { console.error('Failed to fetch linked contacts'); }
//     finally { setLinkedContactsLoading(false); }
//   };

//   const handleSaveNotes = async () => {
//     setNotesSaving(true);
//     try {
//       await companiesAPI.updateNotes(id, notesDraft);
//       setNotes(notesDraft); setEditingNotes(false);
//       toast.success('Notes saved successfully');
//     } catch { toast.error('Failed to save notes'); }
//     finally { setNotesSaving(false); }
//   };

//   const handleCancelNotes = () => { setNotesDraft(notes); setEditingNotes(false); };

//   const handleFieldEdit = (key) => {
//     if (key === 'companyName') { toast.info('Company name cannot be edited'); return; }
//     setEditingField(key);
//   };

//   const handleSave = async (key) => {
//     try {
//       const updateData = { [key]: editValues[key] };
//       await companiesAPI.updateCompany(id, updateData);
//       setCompany(p => ({ ...p, ...updateData }));
//       setEditingField(null);
//       toast.success('Updated successfully');
//     } catch { toast.error('Failed to update field'); setEditValues(company); }
//   };

//   const handleCancel = () => { setEditingField(null); setEditValues(company); };

//   const handleTaskEditSave = async (taskId, payload) => {
//     try {
//       await tasksAPI.updateTask(taskId, payload);
//       toast.success('Task updated successfully');
//       setEditingTask(null);
//       fetchTasks();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to update task');
//     }
//   };

//   const fields = [
//     { key: 'websiteUrl',       label: 'Website',           type: 'text',     icon: Globe },
//     { key: 'industry',         label: 'Industry',          type: 'text',     icon: Tag },
//     { key: 'relationshipType', label: 'Relationship Type', type: 'text',     icon: Tag },
//     { key: 'leadStatus',       label: 'Lead Status',       type: 'text',     icon: Tag },
//     { key: 'leadSource',       label: 'Lead Source',       type: 'text',     icon: Tag },
//     { key: 'companyStage',     label: 'Company Stage',     type: 'text',     icon: BarChart2 },
//     { key: 'legalType',        label: 'Legal Type',        type: 'text',     icon: Briefcase },
//     { key: 'employeeCount',    label: 'Employee Count',    type: 'text',     icon: Users },
//     { key: 'annualRevenue',    label: 'Annual Revenue',    type: 'text',     icon: DollarSign },
//     { key: 'primaryContact',   label: 'Primary Contact',   type: 'text',     icon: UserCheck },
//     { key: 'jobTitle',         label: 'Job Title',         type: 'text',     icon: Briefcase },
//     { key: 'email',            label: 'Email',             type: 'email',    icon: Mail },
//     { key: 'phone',            label: 'Phone',             type: 'tel',      icon: Phone },
//     { key: 'linkedInUrl',      label: 'LinkedIn URL',      type: 'text',     icon: Link2 },
//     { key: 'contactOwner',     label: 'Assigned To',       type: 'select',   icon: UserCheck, options: employeeOptions },
//     { key: 'createdAt',        label: 'Created Date',      type: 'readonly', icon: Clock },
//     { key: 'lastActivity',     label: 'Last Activity',     type: 'readonly', icon: Clock },
//   ];

//   const getDisplay = (f) => {
//     const v = editValues[f.key];
//     if (f.key === 'contactOwner') return employeeNameCache[v] || v || '—';
//     if (f.key === 'createdAt' || f.key === 'lastActivity') return fmt(v);
//     return v || '—';
//   };

//   const taskCounts = {
//     total:      tasks.length,
//     completed:  tasks.filter(t => t.status === 'COMPLETED').length,
//     pending:    tasks.filter(t => t.status === 'PENDING').length,
//     inProgress: tasks.filter(t => t.status === 'IN_PROGRESS').length,
//   };

//   if (loading) return (
//     <div className="flex items-center justify-center h-screen bg-gray-50">
//       <div className="flex flex-col items-center gap-3">
//         <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
//         <p className="text-sm text-gray-500">Loading company…</p>
//       </div>
//     </div>
//   );

//   if (!company) return <div className="p-6 text-center text-red-600">Company not found</div>;

//   const initials = (company.companyName || '?').slice(0, 2).toUpperCase();

//   return (
//     <div className="min-h-screen bg-[#f5f8fa] font-sans">

//       {/* ── Top nav ── */}
//       <div className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between sticky top-0 z-20 shadow-sm">
//         <div className="flex items-center gap-3">
//           <button onClick={() => navigate('/company')}
//             className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800 transition-colors">
//             <ChevronLeft size={16} /> Companies
//           </button>
//           <span className="text-gray-300">/</span>
//           <span className="text-sm font-medium text-gray-800 truncate max-w-xs">{company.companyName}</span>
//         </div>
//       </div>

//       {/* ── 3-column layout ── */}
//       <div className="flex h-[calc(100vh-49px)] overflow-hidden">

//         {/* ── LEFT SIDEBAR — company details ── */}
//         <aside className="w-64 bg-white border-r border-gray-200 flex-shrink-0 h-full overflow-y-auto">
//           <div className="p-4 border-b border-gray-100">
//             <div className="flex items-center gap-3 mb-3">
//               <div className="w-11 h-11 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0 text-blue-700 font-bold text-sm">
//                 {initials}
//               </div>
//               <div className="min-w-0">
//                 <h2 className="font-semibold text-gray-900 text-sm leading-tight">{company.companyName}</h2>
//                 <p className="text-xs text-gray-400 mt-0.5">{company.industry || 'Company'}</p>
//               </div>
//             </div>
//             <div className="flex flex-wrap gap-1.5">
//               {company.leadStatus   && <Badge value={company.leadStatus}   config={LEAD_STATUS_CONFIG} />}
//               {company.companyStage && <Badge value={company.companyStage} config={STAGE_CONFIG} />}
//             </div>
//           </div>
//           <div className="p-4">
//             <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider mb-2">Company Details</p>
//             {fields.map(field => (
//               <SidebarField
//                 key={field.key} field={field}
//                 editingField={editingField} editValues={editValues}
//                 display={getDisplay(field)}
//                 onEdit={() => handleFieldEdit(field.key)}
//                 onSave={() => handleSave(field.key)}
//                 onCancel={handleCancel}
//                 onChange={(e) => setEditValues(p => ({ ...p, [field.key]: e.target.value }))}
//               />
//             ))}
//           </div>
//         </aside>

//         {/* ── CENTER PANEL — notes + tasks + activity ── */}
//         <main className="flex-1 h-full overflow-y-auto min-w-0">
//           {/* Banner */}
//           <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4 flex items-center gap-3">
//             <Building2 size={20} className="text-white/80" />
//             <h1 className="text-white font-semibold text-lg tracking-wide">Company Activity Tracker</h1>
//           </div>

//           <div className="p-5 space-y-5 max-w-2xl">

//             {/* ══ NOTES ══ */}
//             <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
//               <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
//                 <div className="flex items-center gap-2.5">
//                   <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
//                     <FileText size={12} className="text-white" />
//                   </div>
//                   <span className="text-sm font-semibold text-gray-800">Notes</span>
//                 </div>
//                 {notes && !editingNotes && (
//                   <button onClick={() => { setNotesDraft(notes); setEditingNotes(true); }}
//                     className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-blue-600 transition-colors font-medium">
//                     <Edit2 size={12} /> Edit
//                   </button>
//                 )}
//               </div>
//               <div className="px-5 py-4">
//                 {notesLoading ? (
//                   <div className="flex items-center justify-center py-8">
//                     <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
//                   </div>
//                 ) : editingNotes ? (
//                   <div>
//                     <textarea ref={textareaRef} value={notesDraft}
//                       onChange={e => setNotesDraft(e.target.value)} rows={6}
//                       className="w-full px-4 py-3 text-sm text-gray-700 leading-relaxed bg-blue-50 border border-blue-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-400"
//                       placeholder="Write notes about this company…" />
//                     <div className="flex items-center justify-between mt-3">
//                       <span className="text-xs text-gray-400">{notesDraft.length} characters</span>
//                       <div className="flex items-center gap-2">
//                         <button onClick={handleCancelNotes}
//                           className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors font-medium">
//                           <RotateCcw size={11} /> Cancel
//                         </button>
//                         <button onClick={handleSaveNotes} disabled={notesSaving}
//                           className="flex items-center gap-1.5 px-4 py-1.5 text-xs text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors font-semibold disabled:opacity-50">
//                           <Save size={11} /> {notesSaving ? 'Saving…' : 'Save Notes'}
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 ) : notes ? (
//                   <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">{notes}</p>
//                 ) : (
//                   <div className="text-center py-6">
//                     <FileText size={24} className="text-blue-200 mx-auto mb-2" />
//                     <p className="text-sm text-gray-400 mb-3">No notes yet</p>
//                     <button onClick={() => { setNotesDraft(''); setEditingNotes(true); }}
//                       className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
//                       <Plus size={13} /> Add Notes
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* ══ TASKS ══ */}
//             <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
//               <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
//                 <div className="flex items-center gap-2.5">
//                   <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
//                     <ListChecks size={12} className="text-white" />
//                   </div>
//                   <span className="text-sm font-semibold text-gray-800">Tasks</span>
//                   {tasks.length > 0 && (
//                     <span className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-blue-100 text-blue-700">
//                       {tasks.length}
//                     </span>
//                   )}
//                 </div>
//               </div>
//               <div className="p-4">
//                 {tasksLoading ? (
//                   <div className="flex items-center justify-center py-10">
//                     <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
//                   </div>
//                 ) : tasks.length === 0 ? (
//                   <div className="text-center py-8">
//                     <CheckCircle2 size={28} className="text-gray-200 mx-auto mb-2" />
//                     <p className="text-sm text-gray-400">No tasks yet</p>
//                   </div>
//                 ) : (
//                   <div className="space-y-3">
//                     {tasks.map(task => (
//                       <TaskCard key={task.id} task={task} onEdit={setEditingTask} />
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* ══ ACTIVITY ══ */}
//             <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
//               <div className="flex items-center gap-2.5 px-5 py-3 border-b border-gray-100 bg-gray-50">
//                 <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
//                   <Activity size={12} className="text-white" />
//                 </div>
//                 <span className="text-sm font-semibold text-gray-800">Activity</span>
//               </div>
//               <div className="p-4">
//                 {tasks.length > 0 && (
//                   <div className="grid grid-cols-4 gap-3 mb-4">
//                     {[
//                       { label: 'Total',       value: taskCounts.total,      color: 'text-gray-700',  bg: 'bg-gray-50 border-gray-200' },
//                       { label: 'Pending',     value: taskCounts.pending,    color: 'text-amber-600', bg: 'bg-amber-50 border-amber-200' },
//                       { label: 'In Progress', value: taskCounts.inProgress, color: 'text-blue-600',  bg: 'bg-blue-50 border-blue-200' },
//                       { label: 'Completed',   value: taskCounts.completed,  color: 'text-green-600', bg: 'bg-green-50 border-green-200' },
//                     ].map(s => (
//                       <div key={s.label} className={`rounded-lg border p-3 text-center ${s.bg}`}>
//                         <p className={`text-xl font-bold ${s.color}`}>{s.value}</p>
//                         <p className="text-xs text-gray-500 mt-0.5">{s.label}</p>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//                 {tasksLoading ? (
//                   <div className="flex items-center justify-center py-10">
//                     <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
//                   </div>
//                 ) : tasks.length === 0 ? (
//                   <div className="text-center py-8">
//                     <Activity size={28} className="text-gray-200 mx-auto mb-2" />
//                     <p className="text-sm text-gray-400">No activity yet</p>
//                     <p className="text-xs text-gray-300 mt-1">Tasks will appear here</p>
//                   </div>
//                 ) : (
//                   <div className="space-y-3">
//                     {tasks.map(task => (
//                       <TaskCard key={task.id} task={task} onEdit={setEditingTask} />
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="h-4" />
//           </div>
//         </main>

//         {/* ── RIGHT PANEL — linked contacts ── */}
//         <aside className="w-72 bg-white border-l border-gray-200 flex-shrink-0 h-full overflow-y-auto">
//           {/* Header */}
//           <div className="px-4 py-3.5 border-b border-gray-100 bg-gray-50 sticky top-0 z-10">
//             <div className="flex items-center justify-between">
//               <div className="flex items-center gap-2">
//                 <div className="w-6 h-6 rounded-md bg-orange-500 flex items-center justify-center">
//                   <Users size={12} className="text-white" />
//                 </div>
//                 <span className="text-sm font-semibold text-gray-800">Linked Contacts</span>
//                 {linkedContacts.length > 0 && (
//                   <span className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-orange-100 text-orange-700">
//                     {linkedContacts.length}
//                   </span>
//                 )}
//               </div>
//               <button onClick={fetchLinkedContacts}
//                 className="p-1 rounded hover:bg-gray-200 transition-colors" title="Refresh">
//                 <RefreshCw size={13} className="text-gray-400" />
//               </button>
//             </div>
//           </div>

//           {/* Contacts list */}
//           <div className="p-3">
//             {linkedContactsLoading ? (
//               <div className="flex items-center justify-center py-12">
//                 <div className="w-5 h-5 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
//               </div>
//             ) : linkedContacts.length === 0 ? (
//               <div className="text-center py-12 px-3">
//                 <div className="w-12 h-12 rounded-full bg-orange-50 flex items-center justify-center mx-auto mb-3">
//                   <User size={20} className="text-orange-300" />
//                 </div>
//                 <p className="text-sm font-medium text-gray-500 mb-1">No contacts linked</p>
//                 <p className="text-xs text-gray-400 leading-relaxed mb-4">
//                   Link contacts to this company by setting the company ID when creating or editing a contact.
//                 </p>
//                 <button
//                   onClick={() => setShowCreateAssignContactModal(true)}
//                   className="inline-flex items-center gap-2 px-4 py-2 text-xs font-semibold bg-orange-600 text-white rounded-md hover:bg-orange-700 transition-colors"
//                 >
//                   <Plus size={12} /> Create &amp; Assign
//                 </button>
//               </div>
//             ) : (
//               <div className="space-y-2">
//                 {linkedContacts.map(contact => (
//                   <ContactCard
//                     key={contact.id}
//                     contact={contact}
//                     onNavigate={(contactId) => navigate(`/contacts/${contactId}`)}
//                   />
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* Footer hint */}
//           {linkedContacts.length > 0 && (
//             <div className="px-4 py-3 border-t border-gray-100 bg-gray-50">
//               <p className="text-[11px] text-gray-400 text-center">
//                 Hover a contact to open their profile
//               </p>
//             </div>
//           )}
//         </aside>

//       </div>

//       {/* ══ MODALS & DRAWERS ══ */}
//       {showCreateTaskModal && (
//         <CreateTaskModal
//           onClose={() => setShowCreateTaskModal(false)}
//           onCreate={() => {
//             setShowCreateTaskModal(false);
//             toast.success('Task created successfully');
//             fetchTasks();
//           }}
//           linkedAccount={company.id}
//           linkedAccountName={company.companyName}
//         />
//       )}

//       {editingTask && (
//         <TaskEditDrawer
//           task={editingTask}
//           onClose={() => setEditingTask(null)}
//           onSave={handleTaskEditSave}
//         />
//       )}

//       {showCreateAssignContactModal && (
//         <CreateAssignContactModal
//           companyId={company.id}
//           onClose={() => setShowCreateAssignContactModal(false)}
//           onAssigned={() => {
//             setShowCreateAssignContactModal(false);
//             fetchLinkedContacts();
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default CompanyPreviewPage;


import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  ChevronLeft, Save, X, Plus, Building2, Globe, Tag, Users,
  DollarSign, Mail, Phone, Link2, Clock, UserCheck, Briefcase,
  BarChart2, CheckCircle2, Circle, AlertCircle, Calendar,
  Edit2, ListChecks, Activity, FileText, RotateCcw, User,
  ExternalLink, RefreshCw
} from 'lucide-react';
import { companiesAPI, employeesAPI, tasksAPI, contactsAPI } from '../../../services/api';
import { toast } from 'react-toastify';
import CreateTaskModal from '../task/CreateTaskModal';
import TaskEditDrawer from '../task/TaskEditDrawer';
import CreateContactModal from '../contact/CreateContactModal';

/* ─── helpers ─── */
const fmt = (val) =>
  val ? new Date(val).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';

const fmtTime = (val) => {
  if (!val) return '';
  const d = new Date(val);
  const now = new Date();
  const diff = now - d;
  const mins = Math.floor(diff / 60000);
  const hrs  = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  if (mins < 1)  return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  if (hrs < 24)  return `Today, ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
  if (days === 1) return `Yesterday, ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
  return fmt(val);
};

/* ─── Badge configs ─── */
const LEAD_STATUS_CONFIG = {
  NEW:              { color: 'text-blue-600',   bg: 'bg-blue-50 border-blue-200',     dot: 'bg-blue-500' },
  CONTACTED:        { color: 'text-purple-600', bg: 'bg-purple-50 border-purple-200', dot: 'bg-purple-500' },
  QUALIFIED:        { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',   dot: 'bg-green-500' },
  QUALIFIED_LEAD:   { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',   dot: 'bg-green-500' },
  UNQUALIFIED:      { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',       dot: 'bg-red-500' },
  UNQUALIFIED_LEAD: { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',       dot: 'bg-red-500' },
  NURTURING:        { color: 'text-amber-600',  bg: 'bg-amber-50 border-amber-200',   dot: 'bg-amber-500' },
};

const STAGE_CONFIG = {
  PROSPECT: { color: 'text-blue-600',   bg: 'bg-blue-50 border-blue-200',    dot: 'bg-blue-500' },
  LEAD:     { color: 'text-purple-600', bg: 'bg-purple-50 border-purple-200', dot: 'bg-purple-500' },
  CUSTOMER: { color: 'text-green-600',  bg: 'bg-green-50 border-green-200',  dot: 'bg-green-500' },
  CHURNED:  { color: 'text-red-600',    bg: 'bg-red-50 border-red-200',      dot: 'bg-red-500' },
};

const TASK_STATUS_CONFIG = {
  PENDING:     { color: 'text-gray-600',  bg: 'bg-gray-100 border-gray-200',  icon: Circle },
  IN_PROGRESS: { color: 'text-blue-600',  bg: 'bg-blue-50 border-blue-200',   icon: AlertCircle },
  COMPLETED:   { color: 'text-green-600', bg: 'bg-green-50 border-green-200', icon: CheckCircle2 },
  CANCELLED:   { color: 'text-red-600',   bg: 'bg-red-50 border-red-200',     icon: X },
};

const PRIORITY_CONFIG = {
  HIGH:   { color: 'text-red-600',   bg: 'bg-red-50 border-red-200',     label: 'High' },
  MEDIUM: { color: 'text-amber-600', bg: 'bg-amber-50 border-amber-200', label: 'Medium' },
  LOW:    { color: 'text-green-600', bg: 'bg-green-50 border-green-200', label: 'Low' },
};

/* ─── Enum option lists (matching CreateCompanyModal exactly) ─── */
const INDUSTRY_OPTIONS = [
  { value: 'IT',            label: 'IT' },
  { value: 'FINANCE',       label: 'Finance' },
  { value: 'HEALTHCARE',    label: 'Healthcare' },
  { value: 'EDUCATION',     label: 'Education' },
  { value: 'MANUFACTURING', label: 'Manufacturing' },
  { value: 'RETAIL',        label: 'Retail' },
  { value: 'OTHER',         label: 'Other' },
];

const RELATIONSHIP_TYPE_OPTIONS = [
  { value: 'CLIENT',           label: 'Client' },
  { value: 'PARTNER',          label: 'Partner' },
  { value: 'SUPPLIER',         label: 'Supplier' },
  { value: 'VENDOR',           label: 'Vendor' },
  { value: 'DISTRIBUTOR',      label: 'Distributor' },
  { value: 'RESELLER',         label: 'Reseller' },
  { value: 'CONTRACTOR',       label: 'Contractor' },
  { value: 'CONSULTANT',       label: 'Consultant' },
  { value: 'SERVICE_PROVIDER', label: 'Service Provider' },
  { value: 'INVESTOR',         label: 'Investor' },
  { value: 'MANUFACTURER',     label: 'Manufacturer' },
  { value: 'OTHER',            label: 'Other' },
];

const LEAD_STATUS_OPTIONS = [
  { value: 'NEW',       label: 'New' },
  { value: 'CONTACTED', label: 'Contacted' },
  { value: 'QUALIFIED', label: 'Qualified' },
  { value: 'LOST',      label: 'Lost' },
  { value: 'WON',       label: 'Won' },
  { value: 'OTHER',     label: 'Other' },
];

const LEAD_SOURCE_OPTIONS = [
  { value: 'WEBSITE',      label: 'Website' },
  { value: 'REFERRAL',     label: 'Referral' },
  { value: 'PARTNER',      label: 'Partner' },
  { value: 'SOCIAL_MEDIA', label: 'Social Media' },
  { value: 'EMAIL',        label: 'Email' },
  { value: 'CALL',         label: 'Call' },
  { value: 'OTHER',        label: 'Other' },
];

const COMPANY_STAGE_OPTIONS = [
  { value: 'STARTUP',    label: 'Startup' },
  { value: 'SMALL',      label: 'Small' },
  { value: 'MEDIUM',     label: 'Medium' },
  { value: 'LARGE',      label: 'Large' },
  { value: 'ENTERPRISE', label: 'Enterprise' },
  { value: 'OTHER',      label: 'Other' },
];

const LEGAL_TYPE_OPTIONS = [
  { value: 'SOLE_PROPRIETORSHIP', label: 'Sole Proprietorship' },
  { value: 'PARTNERSHIP_FIRM',    label: 'Partnership Firm' },
  { value: 'LLP',                 label: 'LLP' },
  { value: 'PRIVATE_LIMITED',     label: 'Private Limited' },
  { value: 'PUBLIC_LIMITED',      label: 'Public Limited' },
  { value: 'OPC',                 label: 'One Person Company' },
  { value: 'JOINT_VENTURE',       label: 'Joint Venture' },
  { value: 'NON_PROFIT',          label: 'Non-Profit' },
  { value: 'GOVERNMENT_ENTITY',   label: 'Government Entity' },
  { value: 'OTHER',               label: 'Other' },
];

const EMPLOYEE_COUNT_OPTIONS = [
  { value: 'RANGE_1_10',       label: '1–10' },
  { value: 'RANGE_11_50',      label: '11–50' },
  { value: 'RANGE_51_100',     label: '51–100' },
  { value: 'RANGE_101_250',    label: '101–250' },
  { value: 'RANGE_251_500',    label: '251–500' },
  { value: 'RANGE_501_1000',   label: '501–1,000' },
  { value: 'RANGE_1001_5000',  label: '1,001–5,000' },
  { value: 'RANGE_5001_10000', label: '5,001–10,000' },
  { value: 'RANGE_10000_PLUS', label: '10,000+' },
];

const ANNUAL_REVENUE_OPTIONS = [
  { value: 'BELOW_1M',        label: 'Below $1M' },
  { value: 'RANGE_1M_5M',     label: '$1M – $5M' },
  { value: 'RANGE_5M_10M',    label: '$5M – $10M' },
  { value: 'RANGE_10M_50M',   label: '$10M – $50M' },
  { value: 'RANGE_50M_100M',  label: '$50M – $100M' },
  { value: 'RANGE_100M_500M', label: '$100M – $500M' },
  { value: 'RANGE_500M_1B',   label: '$500M – $1B' },
  { value: 'RANGE_1B_5B',     label: '$1B – $5B' },
  { value: 'RANGE_5B_10B',    label: '$5B – $10B' },
  { value: 'ABOVE_10B',       label: 'Above $10B' },
];

const Badge = ({ value, config, className = '' }) => {
  const cfg = config?.[value?.toUpperCase()] || {};
  const Icon = cfg.icon;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border
      ${cfg.bg || 'bg-gray-100 border-gray-200'} ${cfg.color || 'text-gray-600'} ${className}`}>
      {cfg.dot && <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />}
      {Icon && <Icon size={11} />}
      <span>{value?.replace(/_/g, ' ') || '—'}</span>
    </span>
  );
};

/* ─── Sidebar editable row ─── */
const SidebarField = ({ field, editingField, editValues, display, onEdit, onSave, onCancel, onChange }) => {
  const isEditing  = editingField === field.key;
  const isReadonly = field.type === 'readonly';
  const Icon = field.icon;

  // ✅ Renders correct input based on field config
  const renderInput = () => {
    // Employee dropdown
    if (field.type === 'select' && field.options) {
      return (
        <select
          value={editValues[field.key] || ''}
          onChange={onChange}
          className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select…</option>
          {field.options.map(o => (
            <option key={o.id} value={o.id}>
              {o.name || `${o.firstName || ''} ${o.lastName || ''}`.trim() || o.email}
            </option>
          ))}
        </select>
      );
    }
    // Enum dropdown
    if (field.enumOptions) {
      return (
        <select
          value={editValues[field.key] || ''}
          onChange={onChange}
          className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select…</option>
          {field.enumOptions.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      );
    }
    // Plain text input
    return (
      <input
        type={field.type || 'text'}
        value={editValues[field.key] || ''}
        onChange={onChange}
        className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    );
  };

  return (
    <div className="py-2.5 border-b border-gray-50 last:border-0">
      <div className="flex items-center gap-1.5 mb-0.5">
        {Icon && <Icon size={11} className="text-gray-400 flex-shrink-0" />}
        <span className="text-[11px] text-gray-400 font-medium uppercase tracking-wide">{field.label}</span>
      </div>
      {isEditing ? (
        <div className="space-y-1.5 mt-1.5">
          {renderInput()}
          {/* ✅ Save & Cancel always visible when editing */}
          <div className="flex gap-1.5 justify-end">
            <button
              onClick={onCancel}
              className="flex items-center gap-1 px-2 py-1 text-[11px] text-gray-600 bg-gray-100 hover:bg-gray-200 rounded transition-colors"
            >
              <X size={10} /> Cancel
            </button>
            <button
              onClick={onSave}
              className="flex items-center gap-1 px-2 py-1 text-[11px] text-white bg-blue-600 hover:bg-blue-700 rounded transition-colors"
            >
              <Save size={10} /> Save
            </button>
          </div>
        </div>
      ) : (
        <div
          onClick={!isReadonly ? onEdit : undefined}
          className={`text-xs text-gray-800 font-medium mt-0.5 rounded px-1 py-0.5 -mx-1
            ${!isReadonly ? 'cursor-pointer hover:bg-blue-50 hover:text-blue-700 transition-colors' : ''}`}
          title={!isReadonly ? 'Click to edit' : undefined}
        >
          {!display || display === '—'
            ? <span className="text-gray-400 italic font-normal">{isReadonly ? '—' : 'Not set'}</span>
            : display}
        </div>
      )}
    </div>
  );
};

/* ─── Task Card ─── */
const TaskCard = ({ task, onEdit }) => {
  const statusCfg   = TASK_STATUS_CONFIG[task.status] || TASK_STATUS_CONFIG.PENDING;
  const priorityCfg = PRIORITY_CONFIG[task.priority];
  const StatusIcon  = statusCfg.icon;
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 hover:border-blue-300 hover:shadow-sm transition-all">
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="flex items-start gap-2 min-w-0">
          <StatusIcon size={15} className={`mt-0.5 flex-shrink-0 ${statusCfg.color}`} />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-gray-800">{task.subject || '(No Subject)'}</p>
            {task.description && (
              <p className="text-xs text-gray-500 mt-1 line-clamp-2 leading-relaxed">{task.description}</p>
            )}
          </div>
        </div>
        <span className="text-xs text-gray-400 whitespace-nowrap flex-shrink-0">{fmtTime(task.createdAt)}</span>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {task.priority && priorityCfg && (
          <span className={`text-xs font-medium px-2 py-0.5 rounded border ${priorityCfg.bg} ${priorityCfg.color}`}>
            {priorityCfg.label}
          </span>
        )}
        {task.type && (
          <span className="text-xs text-teal-600 bg-teal-50 border border-teal-200 px-2 py-0.5 rounded font-medium">
            {task.type.replace(/_/g, ' ')}
          </span>
        )}
        {task.status && task.status !== 'PENDING' && <Badge value={task.status} config={TASK_STATUS_CONFIG} />}
        {task.dueDate && (
          <div className="flex items-center gap-1 text-xs text-gray-400">
            <Calendar size={11} /> Due: {fmt(task.dueDate)}
          </div>
        )}
      </div>
      <div className="mt-2 pt-2 border-t border-gray-50">
        <button onClick={() => onEdit(task)}
          className="flex items-center gap-1 text-xs text-gray-500 hover:text-blue-600 transition-colors font-medium">
          <Edit2 size={12} /> Edit
        </button>
      </div>
    </div>
  );
};

/* ─── Contact Card (right panel) ─── */
const ContactCard = ({ contact, onNavigate }) => {
  const fullName = `${contact.firstName || ''} ${contact.lastName || ''}`.trim() || '(No Name)';
  const initials = `${contact.firstName?.[0] || ''}${contact.lastName?.[0] || ''}`.toUpperCase() || '?';
  return (
    <div className="flex items-start gap-3 p-3 rounded-lg border border-gray-100 hover:border-blue-200 hover:bg-blue-50/40 transition-all group">
      <div className="w-9 h-9 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0 text-orange-700 font-bold text-xs">
        {initials}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-800 truncate">{fullName}</p>
        {contact.jobTitle && (
          <p className="text-xs text-gray-400 truncate mt-0.5">{contact.jobTitle}</p>
        )}
        {contact.email && (
          <p className="text-xs text-gray-400 truncate mt-0.5">{contact.email}</p>
        )}
        {contact.leadStatus && (
          <Badge value={contact.leadStatus} config={LEAD_STATUS_CONFIG} className="mt-1.5" />
        )}
      </div>
      <button
        onClick={() => onNavigate(contact.id)}
        className="opacity-0 group-hover:opacity-100 p-1 rounded hover:bg-blue-100 transition-all"
        title="View contact"
      >
        <ExternalLink size={13} className="text-blue-500" />
      </button>
    </div>
  );
};

const AddContactModal = ({ companyId, onClose, onDone }) => {
  const [tab, setTab] = useState('create'); // 'create' | 'assign'

  // --- Create tab state ---
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName]   = useState('');
  const [email, setEmail]         = useState('');
  const [phone, setPhone]         = useState('');
  const [jobTitle, setJobTitle]   = useState('');
  const [creating, setCreating]   = useState(false);

  // --- Assign tab state ---
  const [allContacts, setAllContacts]     = useState([]);
  const [contactsLoading, setContactsLoading] = useState(false);
  const [selectedContact, setSelectedContact] = useState('');
  const [assigning, setAssigning]         = useState(false);
  const [showAddContactModal, setShowAddContactModal] = useState(false);

  useEffect(() => {
    if (tab === 'assign') {
      setContactsLoading(true);
      contactsAPI.getAllContacts()
        .then(r => setAllContacts(r.data || []))
        .catch(() => toast.error('Failed to load contacts'))
        .finally(() => setContactsLoading(false));
    }
  }, [tab]);

  const normalizePhone = (val) => {
    if (!val) return val;
    let d = val.replace(/\D/g, "");
    if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
    if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
    return d.length === 10 ? d : val;
  };

  const handleCreate = async () => {
    if (!firstName.trim()) { toast.error('First name is required'); return; }
    if (!email.trim())     { toast.error('Email is required'); return; }
    setCreating(true);
    try {
      await contactsAPI.addContact({
        firstName: firstName.trim(),
        lastName:  lastName.trim(),
        email:     email.trim(),
        phone:     normalizePhone(phone.trim()),
        jobTitle:  jobTitle.trim(),
        companyId,
      });
      toast.success('Contact created & linked!');
      onDone();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to create contact');
    } finally { setCreating(false); }
  };

  const handleAssign = async () => {
    if (!selectedContact) { toast.error('Please select a contact'); return; }
    setAssigning(true);
    try {
      await companiesAPI.linkContact(companyId, selectedContact);
      toast.success('Contact linked to company!');
      onDone();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to link contact');
    } finally { setAssigning(false); }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden">

          {/* Header */}
          <div className="flex items-center justify-between px-5 py-4 border-b bg-gray-50">
            <div className="flex items-center gap-2">
              <Users size={16} className="text-orange-600" />
              <h3 className="text-sm font-semibold text-gray-900">Add Contact</h3>
            </div>
            <button onClick={onClose} className="p-1 rounded hover:bg-gray-200 text-gray-500">
              <X size={16} />
            </button>
          </div>

          {/* Tabs */}
          <div className="flex border-b">
            {[['create', 'Create New'], ['assign', 'Assign Existing']].map(([key, label]) => (
              <button key={key} onClick={() => setTab(key)}
                className={`flex-1 py-2.5 text-xs font-semibold transition-colors
                  ${tab === key
                    ? 'border-b-2 border-orange-500 text-orange-600'
                    : 'text-gray-500 hover:text-gray-700'}`}>
                {label}
              </button>
            ))}
          </div>

          {/* Create Tab */}
          {tab === 'create' && (
            <div className="px-5 py-4 space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)}
                    placeholder="First name"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Last Name</label>
                  <input type="text" value={lastName} onChange={e => setLastName(e.target.value)}
                    placeholder="Last name"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Email <span className="text-red-500">*</span>
                </label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="Contact email"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Phone</label>
                <input type="tel" value={phone} onChange={e => setPhone(e.target.value)}
                  placeholder="Phone"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Job Title</label>
                <input type="text" value={jobTitle} onChange={e => setJobTitle(e.target.value)}
                  placeholder="Job title"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
              </div>
            </div>
          )}

          {/* Assign Tab */}
          {tab === 'assign' && (
            <div className="px-5 py-4">
              <label className="block text-xs font-medium text-gray-700 mb-2">
                Select existing contact
              </label>
              {contactsLoading ? (
                <div className="flex items-center justify-center py-6">
                  <div className="w-5 h-5 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
                </div>
              ) : (
                <select value={selectedContact} onChange={e => setSelectedContact(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500">
                  <option value="">— Select a contact —</option>
                  {allContacts.map(c => (
                    <option key={c.id} value={c.id}>
                      {`${c.firstName || ''} ${c.lastName || ''}`.trim() || c.email}
                      {c.email ? ` (${c.email})` : ''}
                    </option>
                  ))}
                </select>
              )}
              {selectedContact && (() => {
                const c = allContacts.find(x => x.id === selectedContact);
                if (!c) return null;
                return (
                  <div className="mt-3 p-3 bg-orange-50 border border-orange-200 rounded-lg">
                    <p className="text-xs font-semibold text-orange-800">
                      {`${c.firstName || ''} ${c.lastName || ''}`.trim()}
                    </p>
                    {c.jobTitle && <p className="text-xs text-orange-600 mt-0.5">{c.jobTitle}</p>}
                    {c.email    && <p className="text-xs text-orange-600 mt-0.5">{c.email}</p>}
                  </div>
                );
              })()}
            </div>
          )}

          {/* Footer */}
          <div className="flex gap-2 justify-end px-5 py-4 border-t bg-gray-50">
            <button onClick={onClose}
              className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-100 transition-colors">
              Cancel
            </button>
            {tab === 'create' ? (
              <button onClick={handleCreate} disabled={creating}
                className="flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-60 font-medium">
                {creating
                  ? <><div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" /> Creating…</>
                  : <><Plus size={14} /> Create &amp; Link</>}
              </button>
            ) : (
              <button onClick={handleAssign} disabled={assigning || !selectedContact}
                className="flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-60 font-medium">
                {assigning
                  ? <><div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" /> Linking…</>
                  : <><Plus size={14} /> Link Contact</>}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

/* ═══════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════ */
const CompanyPreviewPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [company, setCompany]                     = useState(null);
  const [loading, setLoading]                     = useState(true);
  const [editingField, setEditingField]           = useState(null);
  const [editValues, setEditValues]               = useState({});
  const [employeeOptions, setEmployeeOptions]     = useState([]);
  const [employeeNameCache, setEmployeeNameCache] = useState({});
  const [tasks, setTasks]                         = useState([]);
  const [tasksLoading, setTasksLoading]           = useState(false);

  // Linked contacts (right panel)
  const [linkedContacts, setLinkedContacts]               = useState([]);
  const [linkedContactsLoading, setLinkedContactsLoading] = useState(false);

  // Notes
  const [notes, setNotes]               = useState('');
  const [notesLoading, setNotesLoading] = useState(false);
  const [editingNotes, setEditingNotes] = useState(false);
  const [notesDraft, setNotesDraft]     = useState('');
  const [notesSaving, setNotesSaving]   = useState(false);
  const textareaRef = useRef(null);

  // Modals
 const [showCreateTaskModal, setShowCreateTaskModal]   = useState(false);
const [editingTask, setEditingTask]                   = useState(null);
const [showCreateContactModal, setShowCreateContactModal] = useState(false);
const [showAddContactModal, setShowAddContactModal]   = useState(false);

  useEffect(() => {
    fetchCompany();
    fetchEmployeeOptions();
    fetchNotes();
    fetchTasks();
    fetchLinkedContacts();
  }, [id]);

  useEffect(() => {
    if (!company?.contactOwner) return;
    const ownerId = company.contactOwner;
    if (ownerId in employeeNameCache) return;
    employeesAPI.getEmployeeById(ownerId)
      .then(res => {
        const e = res.data;
        setEmployeeNameCache(p => ({ ...p, [ownerId]: e.name || `${e.firstName || ''} ${e.lastName || ''}`.trim() || e.email || ownerId }));
      })
      .catch(() => setEmployeeNameCache(p => ({ ...p, [ownerId]: ownerId })));
  }, [company?.contactOwner]);

  useEffect(() => {
    if (!company?.notesLastEditedBy) return;
    const editorId = company.notesLastEditedBy;
    if (editorId in employeeNameCache) return;
    employeesAPI.getEmployeeById(editorId)
      .then(res => {
        const e = res.data;
        setEmployeeNameCache(p => ({ ...p, [editorId]: e.name || `${e.firstName || ''} ${e.lastName || ''}`.trim() || e.email || editorId }));
      })
      .catch(() => setEmployeeNameCache(p => ({ ...p, [editorId]: editorId })));
  }, [company?.notesLastEditedBy]);

  useEffect(() => {
    if (editingNotes && textareaRef.current) {
      textareaRef.current.focus();
      const len = textareaRef.current.value.length;
      textareaRef.current.setSelectionRange(len, len);
    }
  }, [editingNotes]);

  const fetchCompany = async () => {
    setLoading(true);
    try {
      const r = await companiesAPI.getCompanyById(id);
      setCompany(r.data); setEditValues(r.data);
    } catch { toast.error('Failed to fetch company details'); navigate('/company'); }
    finally { setLoading(false); }
  };

  const fetchEmployeeOptions = async () => {
    try {
      const r = await employeesAPI.getAllEmployees();
      setEmployeeOptions(r.data.filter(e => Array.isArray(e.roles) && e.roles.some(r => r === 'CRM' || r === 'ROLE_CRM')));
    } catch (e) { console.error(e); }
  };

 const fetchTasks = async () => {
  setTasksLoading(true);
  try {
    const r = await tasksAPI.gettasksbycompany(id);
    const sorted = (r.data || []).sort((a, b) => {
      if (!a.dueDate) return 1;
      if (!b.dueDate) return -1;
      return new Date(b.dueDate) - new Date(a.dueDate); // latest first
    });
    setTasks(sorted);
  } catch { toast.error('Failed to fetch tasks'); }
  finally { setTasksLoading(false); }
};

  const fetchNotes = async () => {
    setNotesLoading(true);
    try {
      const r = await companiesAPI.getNotes(id);
      const n = typeof r.data?.notes === 'string' ? r.data.notes : '';
      setNotes(n); setNotesDraft(n);
    } catch { console.error('Failed to fetch notes'); }
    finally { setNotesLoading(false); }
  };

  const fetchLinkedContacts = async () => {
    setLinkedContactsLoading(true);
    try {
      const r = await companiesAPI.getLinkedContacts(id);
      setLinkedContacts(r.data || []);
    } catch { console.error('Failed to fetch linked contacts'); }
    finally { setLinkedContactsLoading(false); }
  };

  const handleSaveNotes = async () => {
    setNotesSaving(true);
    try {
      await companiesAPI.updateNotes(id, notesDraft);
      setNotes(notesDraft); setEditingNotes(false);
      toast.success('Notes saved successfully');
    } catch { toast.error('Failed to save notes'); }
    finally { setNotesSaving(false); }
  };

  const handleCancelNotes = () => { setNotesDraft(notes); setEditingNotes(false); };

  const handleFieldEdit = (key) => {
    if (key === 'companyName') { toast.info('Company name cannot be edited'); return; }
    setEditingField(key);
  };

  const handleSave = async (key) => {
    try {
      const updateData = { [key]: editValues[key] };
      await companiesAPI.updateCompany(id, updateData);
      setCompany(p => ({ ...p, ...updateData }));
      setEditingField(null);
      toast.success('Updated successfully');
    } catch { toast.error('Failed to update field'); setEditValues(company); }
  };

  const handleCancel = () => { setEditingField(null); setEditValues(company); };

  const handleTaskEditSave = async (taskId, payload) => {
    try {
      await tasksAPI.updateTask(taskId, payload);
      toast.success('Task updated successfully');
      setEditingTask(null);
      fetchTasks();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update task');
    }
  };

  // ✅ All enum fields now have enumOptions for proper <select> dropdowns in sidebar
  const fields = [
    { key: 'websiteUrl',       label: 'Website',           type: 'text',     icon: Globe },
    { key: 'industry',         label: 'Industry',          type: 'text',     icon: Tag,      enumOptions: INDUSTRY_OPTIONS },
    { key: 'relationshipType', label: 'Relationship Type', type: 'text',     icon: Tag,      enumOptions: RELATIONSHIP_TYPE_OPTIONS },
    { key: 'leadStatus',       label: 'Lead Status',       type: 'text',     icon: Tag,      enumOptions: LEAD_STATUS_OPTIONS },
    { key: 'leadSource',       label: 'Lead Source',       type: 'text',     icon: Tag,      enumOptions: LEAD_SOURCE_OPTIONS },
    { key: 'companyStage',     label: 'Company Stage',     type: 'text',     icon: BarChart2, enumOptions: COMPANY_STAGE_OPTIONS },
    { key: 'legalType',        label: 'Legal Type',        type: 'text',     icon: Briefcase, enumOptions: LEGAL_TYPE_OPTIONS },
    { key: 'employeeCount',    label: 'Employee Count',    type: 'text',     icon: Users,    enumOptions: EMPLOYEE_COUNT_OPTIONS },
    { key: 'annualRevenue',    label: 'Annual Revenue',    type: 'text',     icon: DollarSign, enumOptions: ANNUAL_REVENUE_OPTIONS },
    { key: 'primaryContact',   label: 'Primary Contact',   type: 'text',     icon: UserCheck },
    { key: 'jobTitle',         label: 'Job Title',         type: 'text',     icon: Briefcase },
    { key: 'email',            label: 'Email',             type: 'email',    icon: Mail },
    { key: 'phone',            label: 'Phone',             type: 'tel',      icon: Phone },
    { key: 'linkedInUrl',      label: 'LinkedIn URL',      type: 'text',     icon: Link2 },
    { key: 'contactOwner',     label: 'Assigned To',       type: 'select',   icon: UserCheck, options: employeeOptions },
    { key: 'createdAt',        label: 'Created Date',      type: 'readonly', icon: Clock },
    { key: 'lastActivity',     label: 'Last Activity',     type: 'readonly', icon: Clock },
  ];

  const getDisplay = (f) => {
    const v = editValues[f.key];
    if (f.key === 'contactOwner') return employeeNameCache[v] || v || '—';
    if (f.key === 'createdAt' || f.key === 'lastActivity') return fmt(v);
    // ✅ Show human-readable label for enum fields
    if (f.enumOptions) {
      const opt = f.enumOptions.find(o => o.value === v);
      return opt ? opt.label : (v?.replace(/_/g, ' ') || '—');
    }
    return v || '—';
  };

  const taskCounts = {
    total:      tasks.length,
    completed:  tasks.filter(t => t.status === 'COMPLETED').length,
    pending:    tasks.filter(t => t.status === 'PENDING').length,
    inProgress: tasks.filter(t => t.status === 'IN_PROGRESS').length,
  };

  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-gray-500">Loading company…</p>
      </div>
    </div>
  );

  if (!company) return <div className="p-6 text-center text-red-600">Company not found</div>;

  const initials = (company.companyName || '?').slice(0, 2).toUpperCase();

  return (
    <div className="min-h-screen bg-[#f5f8fa] font-sans">

      {/* ── Top nav ── */}
      <div className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between sticky top-0 z-20 shadow-sm">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate('/company')}
            className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800 transition-colors">
            <ChevronLeft size={16} /> Companies
          </button>
          <span className="text-gray-300">/</span>
          <span className="text-sm font-medium text-gray-800 truncate max-w-xs">{company.companyName}</span>
        </div>
      </div>

      {/* ── 3-column layout ── */}
      <div className="flex h-[calc(100vh-49px)] overflow-hidden">

        {/* ── LEFT SIDEBAR — company details ── */}
        <aside className="w-64 bg-white border-r border-gray-200 flex-shrink-0 h-full overflow-y-auto">
          <div className="p-4 border-b border-gray-100">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0 text-blue-700 font-bold text-sm">
                {initials}
              </div>
              <div className="min-w-0">
                <h2 className="font-semibold text-gray-900 text-sm leading-tight">{company.companyName}</h2>
                <p className="text-xs text-gray-400 mt-0.5">{company.industry || 'Company'}</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {company.leadStatus   && <Badge value={company.leadStatus}   config={LEAD_STATUS_CONFIG} />}
              {company.companyStage && <Badge value={company.companyStage} config={STAGE_CONFIG} />}
            </div>
          </div>
          <div className="p-4">
            <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider mb-2">Company Details</p>
            {fields.map(field => (
              <SidebarField
                key={field.key}
                field={field}
                editingField={editingField}
                editValues={editValues}
                display={getDisplay(field)}
                onEdit={() => handleFieldEdit(field.key)}
                onSave={() => handleSave(field.key)}
                onCancel={handleCancel}
                onChange={(e) => setEditValues(p => ({ ...p, [field.key]: e.target.value }))}
              />
            ))}
          </div>
        </aside>

        {/* ── CENTER PANEL — notes + tasks + activity ── */}
        <main className="flex-1 h-full overflow-y-auto min-w-0">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4 flex items-center gap-3">
            <Building2 size={20} className="text-white/80" />
            <h1 className="text-white font-semibold text-lg tracking-wide">Company Activity Tracker</h1>
          </div>

          <div className="p-5 space-y-5 max-w-2xl">

            {/* ══ NOTES ══ */}
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
                <div className="flex items-center gap-2.5">
                  <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
                    <FileText size={12} className="text-white" />
                  </div>
                  <span className="text-sm font-semibold text-gray-800">Notes</span>
                  {company?.notesLastEditedAt && (
                    <span className="text-xs text-gray-400">
                      · Last edited by {employeeNameCache[company.notesLastEditedBy] || company.notesLastEditedBy} on {new Date(company.notesLastEditedAt).toLocaleString()}
                    </span>
                  )}
                </div>
                {notes && !editingNotes && (
                  <button onClick={() => { setNotesDraft(notes); setEditingNotes(true); }}
                    className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-blue-600 transition-colors font-medium">
                    <Edit2 size={12} /> Edit
                  </button>
                )}
              </div>
              <div className="px-5 py-4">
                {notesLoading ? (
                  <div className="flex items-center justify-center py-8">
                    <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                  </div>
                ) : editingNotes ? (
                  <div>
                    <textarea ref={textareaRef} value={notesDraft}
                      onChange={e => setNotesDraft(e.target.value)} rows={6}
                      className="w-full px-4 py-3 text-sm text-gray-700 leading-relaxed bg-blue-50 border border-blue-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-400"
                      placeholder="Write notes about this company…" />
                    <div className="flex items-center justify-between mt-3">
                      <span className="text-xs text-gray-400">{notesDraft.length} characters</span>
                      <div className="flex items-center gap-2">
                        <button onClick={handleCancelNotes}
                          className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors font-medium">
                          <RotateCcw size={11} /> Cancel
                        </button>
                        <button onClick={handleSaveNotes} disabled={notesSaving}
                          className="flex items-center gap-1.5 px-4 py-1.5 text-xs text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors font-semibold disabled:opacity-50">
                          <Save size={11} /> {notesSaving ? 'Saving…' : 'Save Notes'}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : notes ? (
                  <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">{notes}</p>
                ) : (
                  <div className="text-center py-6">
                    <FileText size={24} className="text-blue-200 mx-auto mb-2" />
                    <p className="text-sm text-gray-400 mb-3">No notes yet</p>
                    <button onClick={() => { setNotesDraft(''); setEditingNotes(true); }}
                      className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                      <Plus size={13} /> Add Notes
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* ══ TASKS ══ */}
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
                <div className="flex items-center gap-2.5">
                  <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
                    <ListChecks size={12} className="text-white" />
                  </div>
                  <span className="text-sm font-semibold text-gray-800">Tasks</span>
                  {tasks.length > 0 && (
                    <span className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-blue-100 text-blue-700">
                      {tasks.length}
                    </span>
                  )}
                </div>
                <button
                  onClick={() => setShowCreateTaskModal(true)}
                  className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                >
                  <Plus size={13} /> Create Task
                </button>
              </div>
              <div className="p-4">
                {tasksLoading ? (
                  <div className="flex items-center justify-center py-10">
                    <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                  </div>
                ) : tasks.length === 0 ? (
                  <div className="text-center py-8">
                    <CheckCircle2 size={28} className="text-gray-200 mx-auto mb-2" />
                    <p className="text-sm text-gray-400 mb-3">No tasks yet</p>
                    <button
                      onClick={() => setShowCreateTaskModal(true)}
                      className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                    >
                      <Plus size={13} /> Create Task
                    </button>
                  </div>
                ) : (
                  <div className="space-y-3">
                    {tasks.map(task => (
                      <TaskCard key={task.id} task={task} onEdit={setEditingTask} />
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* ══ ACTIVITY ══ */}
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <div className="flex items-center gap-2.5 px-5 py-3 border-b border-gray-100 bg-gray-50">
                <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
                  <Activity size={12} className="text-white" />
                </div>
                <span className="text-sm font-semibold text-gray-800">Activity</span>
              </div>
              <div className="p-4">
                {tasks.length > 0 && (
                  <div className="grid grid-cols-4 gap-3 mb-4">
                    {[
                      { label: 'Total',       value: taskCounts.total,      color: 'text-gray-700',  bg: 'bg-gray-50 border-gray-200' },
                      { label: 'Pending',     value: taskCounts.pending,    color: 'text-amber-600', bg: 'bg-amber-50 border-amber-200' },
                      { label: 'In Progress', value: taskCounts.inProgress, color: 'text-blue-600',  bg: 'bg-blue-50 border-blue-200' },
                      { label: 'Completed',   value: taskCounts.completed,  color: 'text-green-600', bg: 'bg-green-50 border-green-200' },
                    ].map(s => (
                      <div key={s.label} className={`rounded-lg border p-3 text-center ${s.bg}`}>
                        <p className={`text-xl font-bold ${s.color}`}>{s.value}</p>
                        <p className="text-xs text-gray-500 mt-0.5">{s.label}</p>
                      </div>
                    ))}
                  </div>
                )}
                {tasksLoading ? (
                  <div className="flex items-center justify-center py-10">
                    <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                  </div>
                ) : tasks.length === 0 ? (
                  <div className="text-center py-8">
                    <Activity size={28} className="text-gray-200 mx-auto mb-2" />
                    <p className="text-sm text-gray-400">No activity yet</p>
                    <p className="text-xs text-gray-300 mt-1">Tasks will appear here</p>
                  </div>
                ) : (
                  <div className="space-y-3">
                    {tasks.map(task => (
                      <TaskCard key={task.id} task={task} onEdit={setEditingTask} />
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="h-4" />
          </div>
        </main>

        {/* ── RIGHT PANEL — linked contacts ── */}
        <aside className="w-72 bg-white border-l border-gray-200 flex-shrink-0 h-full overflow-y-auto">
          <div className="px-4 py-3.5 border-b border-gray-100 bg-gray-50 sticky top-0 z-10">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-md bg-[#1C4E6D] flex items-center justify-center">
                  <Users size={12} className="text-white" />
                </div>
                <span className="text-sm font-semibold text-gray-800">Linked Contacts</span>
                {linkedContacts.length > 0 && (
                  <span className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-[#e8f0f5] text-[#1C4E6D]">
                    {linkedContacts.length}
                  </span>
                )}
              </div>
              <div className="flex items-center gap-1.5">
<button
  onClick={() => setShowAddContactModal(true)}
  className="flex items-center gap-1 px-2.5 py-1.5 text-[11px] font-semibold bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
>
  <Plus size={11} /> Add Contact
</button>
                <button onClick={fetchLinkedContacts}
                  className="p-1 rounded hover:bg-gray-200 transition-colors" title="Refresh">
                  <RefreshCw size={13} className="text-gray-400" />
                </button>
              </div>
            </div>
          </div>

          <div className="p-3">
            {linkedContactsLoading ? (
              <div className="flex items-center justify-center py-12">
                <div className="w-5 h-5 border-2 border-[#1C4E6D] border-t-transparent rounded-full animate-spin" />
              </div>
            ) : linkedContacts.length === 0 ? (
              <div className="text-center py-12 px-3">
                <div className="w-12 h-12 rounded-full bg-[#e8f0f5] flex items-center justify-center mx-auto mb-3">
                  <User size={20} className="text-[#1C4E6D]" />
                </div>
                <p className="text-sm font-medium text-gray-500 mb-1">No contacts linked</p>
                <p className="text-xs text-gray-400 leading-relaxed mb-4">
                  Create a contact and assign them to this company.
                </p>
                <button
                  onClick={() => setShowCreateContactModal(true)}
                  className="inline-flex items-center gap-2 px-4 py-2 text-xs font-semibold bg-[#1C4E6D] text-white rounded-md hover:bg-[#153a4f] transition-colors"
                >
                  <Plus size={12} /> Create &amp; Assign
                </button>
              </div>
            ) : (
              <div className="space-y-2">
                {linkedContacts.map(contact => (
                  <ContactCard
                    key={contact.id}
                    contact={contact}
                    onNavigate={(contactId) => navigate(`/contacts/${contactId}`)}
                  />
                ))}
                {/* <button
                  onClick={() => setShowCreateContactModal(true)}
                  className="w-full mt-1 flex items-center justify-center gap-2 py-2.5 text-xs font-semibold text-orange-600 border border-dashed border-orange-300 rounded-lg hover:bg-orange-50 transition-colors"
                >
                  <Plus size={12} /> Add Another Contact
                </button> */}
              </div>
            )}
          </div>

          {linkedContacts.length > 0 && (
            <div className="px-4 py-3 border-t border-gray-100 bg-gray-50">
              <p className="text-[11px] text-gray-400 text-center">
                Hover a contact to open their profile
              </p>
            </div>
          )}
        </aside>

      </div>

      {/* ══ MODALS & DRAWERS ══ */}
      {showCreateTaskModal && (
        <CreateTaskModal
          onClose={() => setShowCreateTaskModal(false)}
          onCreate={() => {
            setShowCreateTaskModal(false);
            toast.success('Task created successfully');
            fetchTasks();
          }}
          linkedAccount={company.id}
          linkedAccountName={company.companyName}
        />
      )}

      {editingTask && (
        <TaskEditDrawer
          task={editingTask}
          onClose={() => setEditingTask(null)}
          onSave={handleTaskEditSave}
        />
      )}

      {showAddContactModal && (
  <AddContactModal
    companyId={company.id}
    onClose={() => setShowAddContactModal(false)}
    onDone={() => {
      setShowAddContactModal(false);
      fetchLinkedContacts();
    }}
  />
)}
    </div>
  );
};

export default CompanyPreviewPage;